module.exports = __webpack_public_path__ + "static/img/productsone.ac6c4c93.png";